import { render } from "./OverviewItem.vue?vue&type=template&id=3cfd9cd0&ts=true"
import script from "./OverviewItem.vue?vue&type=script&lang=ts"
export * from "./OverviewItem.vue?vue&type=script&lang=ts"

import exportComponent from "/builds/bizerba/bizerba-web/light-modules/bizerba/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__